import { HabitSchedule, ScheduleFrequency } from '@griply/types';

import { getStoredEndDate } from './get-display-end-date';

export type ScheduleEditDraft = {
  startDate: Date;
  endDate: Date | null;
  completionTargetCount: number;
  startTime: number | null;
  duration: number | null;
  rrule: HabitSchedule['rrule'];
  frequency: ScheduleFrequency | null;
};

// rrule/frequency come from the draft, not the live schedule, so the save-time prompt sees a recurrence change.
export const buildUpdatedSchedule = (
  schedule: HabitSchedule,
  draft: ScheduleEditDraft,
): HabitSchedule => ({
  ...schedule,
  rrule: draft.rrule,
  frequency: draft.frequency,
  startDate: draft.startDate,
  endDate: getStoredEndDate(draft.endDate),
  completionTarget: {
    ...schedule.completionTarget,
    count: draft.completionTargetCount,
  },
  timeslot: {
    ...schedule.timeslot,
    startTime: draft.startTime,
    duration: draft.duration,
  },
});
